import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IconService } from './services/icon.service';

@Component({
  selector: 'bcac-icon',
  templateUrl: './bcac-icon.component.html',
  styleUrls: ['./bcac-icon.component.scss'],
  host: {
    '[class.bcac-icon-lg]': `iconSize === 'large'`,
    '[class.bcac-icon-sm]': `iconSize === 'small'`
  }
})
export class BcacIconComponent implements OnInit {

  constructor(
    public iconService: IconService
  ) { }

  ngOnInit() {
    this.assignIcon()
    // if (this.iconType === "add") {
    //   this.iconHtml = this.iconService.getAddIcon;
    // } else if (this.iconType === "config") {
    //   this.iconHtml = this.iconService.getConfigSvg;
    // } else if (this.iconType === "delete") {
    //   this.iconHtml = this.iconService.getDeleteIcon;
    // } else if (this.iconType === "save") {
    //   this.iconHtml = this.iconService.getSaveIcon;
    // } else if (this.iconType === "excel_out") {
    //   this.iconHtml = this.iconService.getExcelIcon;
    // } else if (this.iconType === "pdf_out") {
    //   this.iconHtml = this.iconService.getPdfIcon;
    // } else if (this.iconType === "batch_download") {
    //   this.iconHtml = this.iconService.getDownloadPackageIcon;
    // } else if (this.iconType === "import") {
    //   this.iconHtml = this.iconService.getImportIcon;
    // } else if (this.iconType === "calculate") {
    //   this.iconHtml = this.iconService.getCalculateIcon;
    // } else if (this.iconType === "detail") {
    //   this.iconHtml = this.iconService.getDetailsIcon;
    // } else if (this.iconType === "editor") {
    //   this.iconHtml = this.iconService.getEditIcon;
    // } else if (this.iconType === "download") {
    //   this.iconHtml = this.iconService.getDownloadIcon;
    // } else if (this.iconType === "review") {
    //   this.iconHtml = this.iconService.getReviewIcon;
    // } else if (this.iconType === "report") {
    //   this.iconHtml = this.iconService.getGenerateReportIcon;
    // } else if (this.iconType === "preview") {
    //   this.iconHtml = this.iconService.getPreviewIcon;
    // } else if (this.iconType === "calendar") {
    //   this.iconHtml = this.iconService.getCalendarIcon;
    // } else if (this.iconType === "day_time") {
    //   this.iconHtml = this.iconService.getDayTimeIcon;
    // } else if (this.iconType === "night_time") {
    //   this.iconHtml = this.iconService.getNightIcon;
    // } else if (this.iconType === "temperature") {
    //   this.iconHtml = this.iconService.getTemperatureIcon;
    // } else if (this.iconType === "wind_speed") {
    //   this.iconHtml = this.iconService.getWindSpeedIconSvg;
    // } else if (this.iconType === "rain_fall") {
    //   this.iconHtml = this.iconService.getRainFallIconSvg;
    // } else if (this.iconType === "humidity") {
    //   this.iconHtml = this.iconService.getHumidityIcon;
    // } else if (this.iconType === "air_pressure") {
    //   this.iconHtml = this.iconService.getAirPressureIconSvg;
    // } else if (this.iconType === "wind_direction") {
    //   this.iconHtml = this.iconService.getWindDirectionIcon;
    // } else if (this.iconType === "home_point") {
    //   this.iconHtml = this.iconService.getHomePointIcon;
    // } else if (this.iconType === "range") {
    //   this.iconHtml = this.iconService.getRangIcon;
    // } else if (this.iconType === "refresh") {
    //   this.iconHtml = this.iconService.getRefreshIcon;
    // } else if (this.iconType === "print") {
    //   this.iconHtml = this.iconService.getPrintIcon;
    // } else if (this.iconType === "layer_switch") {
    //   this.iconHtml = this.iconService.getLayerSwitchIcon;
    // } else if (this.iconType === "map_site") {
    //   this.iconHtml = this.iconService.getMapSiteIcon;
    // } else if (this.iconType === "noise") {
    //   this.iconHtml = this.iconService.getNoiseIcon;
    // } else if (this.iconType === "template_download") {
    //   this.iconHtml = this.iconService.getDownloadTemplateIcon;
    // } else if (this.iconType === "data_inject") {
    //   this.iconHtml = this.iconService.getDataInjectionIcon;
    // } else if (this.iconType === "copy_table") {
    //   this.iconHtml = this.iconService.getCopyTableIcon;
    // } else if (this.iconType === "copy_picture") {
    //   this.iconHtml = this.iconService.getCopyPictureIcon;
    // } else if (this.iconType === "handle_work_order") {
    //   this.iconHtml = this.iconService.getHandleWorkOrderIcon;
    // } else if (this.iconType === "receive_work_order") {
    //   this.iconHtml = this.iconService.getReceiveWorkOrderIconSvg;
    // } else if (this.iconType === "transfer_work_order") {
    //   this.iconHtml = this.iconService.getTransferOrderIcon;
    // } else if (this.iconType === "fill_in") {
    //   this.iconHtml = this.iconService.getFillInIcon;
    // } else if (this.iconType === "turn_down") {
    //   this.iconHtml = this.iconService.getTurnDownIconSvg;
    // } else if (this.iconType === "report_open") {
    //   this.iconHtml = this.iconService.getReportOpenIcon;
    // } else if (this.iconType === "report_pack") {
    //   this.iconHtml = this.iconService.getReportPackIcon;
    // } else if (this.iconType === "change_table") {
    //   this.iconHtml = this.iconService.getChangeTableSvg;
    // } else if (this.iconType === "review_record") {
    //   this.iconHtml = this.iconService.getReviewRecordIcon;
    // } else if (this.iconType === "submit") {
    //   this.iconHtml = this.iconService.getSubmitIcon;
    // } else if (this.iconType === "new_user") {
    //   this.iconHtml = this.iconService.getNewUserIconSvg;
    // } else if (this.iconType === "new_role") {
    //   this.iconHtml = this.iconService.getNewRoleIconSvg;
    // } else if (this.iconType === "distribute_order") {
    //   this.iconHtml = this.iconService.getDistributeOrder;
    // } else if (this.iconType === "clear") {
    //   this.iconHtml = this.iconService.getClearIconSvg;
    // } else if (this.iconType === "legend") {
    //   this.iconHtml = this.iconService.getLegendIconSvg;
    // } else if (this.iconType === "axis-scale") {
    //   this.iconHtml = this.iconService.getAxisScaleIconSvg;
    // } else if (this.iconType === "map_refresh") {
    //   this.iconHtml = this.iconService.getMapRefreshIcon;
    // } else if (this.iconType === "chart_menu") {
    //   this.iconHtml = this.iconService.getChartMenuIconSvg;
    // } else if (this.iconType === 'export_excel') {
    //   this.iconHtml = this.iconService.getEchartsExcelExportIcon;
    // } else if (this.iconType === 'zoom_enlarge') {
    //   this.iconHtml = this.iconService.getZoomEnlargeSvg;
    // } else if (this.iconType === 'zoom_back') {
    //   this.iconHtml = this.iconService.getZoomRestoreSvg;
    // }
    // else if (this.iconType === 'brush') {
    //   this.iconHtml = this.iconService.getBrushSvg;
    // }
    // else if (this.iconType === 'brush_clear') {
    //   this.iconHtml = this.iconService.getBrushClearSvg;
    // } else if (this.iconType === 'brush_enlarge') {
    //   this.iconHtml = this.iconService.getBrushEnlargeSvg;
    // } else if (this.iconType === 'brush_restore') {
    //   this.iconHtml = this.iconService.getBrushRestoreSvg;
    // } else if (this.iconType === 'map_reload') {
    //   this.iconHtml = this.iconService.getMapReloadIcon;
    // } else if (this.iconType === 'spec') {
    //   this.iconHtml = this.iconService.getSpecSvg;
    // } else if (this.iconType === 'menu_authority') {
    //   this.iconHtml = this.iconService.getMenuAuthority;
    // }
    // else {
    //   this.iconHtml = this.iconService.getAddIcon;
    // }


  }

  assignIcon(){
    switch (this.iconType) {
      case "add":
        this.iconHtml = this.iconService.getAddIcon;
        break
      case "config":
        this.iconHtml = this.iconService.getConfigSvg;
        break
      case "delete":
        this.iconHtml = this.iconService.getDeleteIcon;
        break
      case "save":
        this.iconHtml = this.iconService.getSaveIcon;
        break
      case "excel_out":
        this.iconHtml = this.iconService.getExcelIcon;
        break
      case "pdf_out":
        this.iconHtml = this.iconService.getPdfIcon;
        break
      case "batch_download":
        this.iconHtml = this.iconService.getDownloadPackageIcon;
        break
      case "import":
        this.iconHtml = this.iconService.getImportIcon;
        break
      case "calculate":
        this.iconHtml = this.iconService.getCalculateIcon;
        break
      case "detail":
        this.iconHtml = this.iconService.getDetailsIcon;
        break
      case "editor":
        this.iconHtml = this.iconService.getEditIcon;
        break
      case "download":
        this.iconHtml = this.iconService.getDownloadIcon;
        break
      case "review":
        this.iconHtml = this.iconService.getReviewIcon;
        break
      case "report":
        this.iconHtml = this.iconService.getGenerateReportIcon;
        break
      case "preview":
        this.iconHtml = this.iconService.getPreviewIcon;
        break
      case "calendar":
        this.iconHtml = this.iconService.getCalendarIcon;
        break
      case "day_time":
        this.iconHtml = this.iconService.getDayTimeIcon;
        break
      case "night_time":
        this.iconHtml = this.iconService.getNightIcon;
        break
      case "temperature":
        this.iconHtml = this.iconService.getTemperatureIcon;
        break
      case "wind_speed":
        this.iconHtml = this.iconService.getWindSpeedIconSvg;
        break
      case "rain_fall":
        this.iconHtml = this.iconService.getRainFallIconSvg;
        break
      case "humidity":
        this.iconHtml = this.iconService.getHumidityIcon;
        break
      case "air_pressure":
        this.iconHtml = this.iconService.getAirPressureIconSvg;
        break
      case "wind_direction":
        this.iconHtml = this.iconService.getWindDirectionIcon;
        break
      case "home_point":
        this.iconHtml = this.iconService.getHomePointIcon;
        break
      case "range":
        this.iconHtml = this.iconService.getRangIcon;
        break
      case "refresh":
        this.iconHtml = this.iconService.getRefreshIcon;
        break
      case "print":
        this.iconHtml = this.iconService.getPrintIcon;
        break
      case "layer_switch":
        this.iconHtml = this.iconService.getLayerSwitchIcon;
        break
      case "map_site":
        this.iconHtml = this.iconService.getMapSiteIcon;
        break
      case "noise":
        this.iconHtml = this.iconService.getNoiseIcon;
        break
      case "template_download":
        this.iconHtml = this.iconService.getDownloadTemplateIcon;
        break
      case "data_inject":
        this.iconHtml = this.iconService.getDataInjectionIcon;
        break
      case "copy_table":
        this.iconHtml = this.iconService.getCopyTableIcon;
        break
      case "copy_picture":
        this.iconHtml = this.iconService.getCopyPictureIcon;
        break
      case "handle_work_order":
        this.iconHtml = this.iconService.getHandleWorkOrderIcon;
        break
      case "receive_work_order":
        this.iconHtml = this.iconService.getReceiveWorkOrderIconSvg;
        break
      case "transfer_work_order":
        this.iconHtml = this.iconService.getTransferOrderIcon;
        break
      case "fill_in":
        this.iconHtml = this.iconService.getFillInIcon;
        break
      case "turn_down":
        this.iconHtml = this.iconService.getTurnDownIconSvg;
        break
      case "report_open":
        this.iconHtml = this.iconService.getReportOpenIcon;
        break
      case "report_pack":
        this.iconHtml = this.iconService.getReportPackIcon;
        break
      case "change_table":
        this.iconHtml = this.iconService.getChangeTableSvg;
        break
      case "review_record":
        this.iconHtml = this.iconService.getReviewRecordIcon;
        break
      case "submit":
        this.iconHtml = this.iconService.getSubmitIcon;
        break
      case "new_user":
        this.iconHtml = this.iconService.getNewUserIconSvg;
        break
      case "new_role":
        this.iconHtml = this.iconService.getNewRoleIconSvg;
        break
      case "distribute_order":
        this.iconHtml = this.iconService.getDistributeOrder;
        break
      case "clear":
        this.iconHtml = this.iconService.getClearIconSvg;
        break
      case "legend":
        this.iconHtml = this.iconService.getLegendIconSvg;
        break
      case "axis-scale":
        this.iconHtml = this.iconService.getAxisScaleIconSvg;
        break
      case "map_refresh":
        this.iconHtml = this.iconService.getMapRefreshIcon;
        break
      case "chart_menu":
        this.iconHtml = this.iconService.getChartMenuIconSvg;
        break
      case 'export_excel':
        this.iconHtml = this.iconService.getEchartsExcelExportIcon;
        break
      case 'zoom_enlarge':
        this.iconHtml = this.iconService.getZoomEnlargeSvg;
        break
      case 'zoom_back':
        this.iconHtml = this.iconService.getZoomRestoreSvg;
        break
      case 'brush':
        this.iconHtml = this.iconService.getBrushSvg;
        break
      case 'brush_clear':
        this.iconHtml = this.iconService.getBrushClearSvg;
        break
      case 'brush_enlarge':
        this.iconHtml = this.iconService.getBrushEnlargeSvg;
        break
      case 'brush_restore':
        this.iconHtml = this.iconService.getBrushRestoreSvg;
        break
      case 'map_reload':
        this.iconHtml = this.iconService.getMapReloadIcon;
        break
      case 'spec':
        this.iconHtml = this.iconService.getSpecSvg;
        break
      case 'menu_authority':
        this.iconHtml = this.iconService.getMenuAuthority;
        break
      case "dashboard": //数据看板
        this.iconHtml = this.iconService.getDashboardIcon;
        break
      case "operation-monitor"://运行监控
        this.iconHtml = this.iconService.getOperationMonitorIcon;
        break
      case "vedio": //视频监控
        this.iconHtml = this.iconService.getVedioIcon;
        break
      case "realtime-data"://实时数据
        this.iconHtml = this.iconService.getRealTimeDataIcon;
        break
      case "airport-noise"://机场噪声
        this.iconHtml = this.iconService.getAirPortNoiseIcon;
        break
      case "airquality"://空气质量
        this.iconHtml = this.iconService.getAirQualityIcon;
        break
      case "terminal"://航站楼微环境
        this.iconHtml = this.iconService.getTerminalIcon;
        break
      case "complaint"://投诉管理
        this.iconHtml = this.iconService.getComplaintIcon;
        break
      case "system"://系统
        this.iconHtml = this.iconService.getSystemIcon;
        break
      case "maintain"://运维
        this.iconHtml = this.iconService.getMaintainIcon;
        break
      case "description"://描述
        this.iconHtml = this.iconService.getDescriptionIcon;
        break
      case "logout"://登出
        this.iconHtml = this.iconService.getLogoutIcon;
        break
      case "setting"://设置
        this.iconHtml = this.iconService.getSettingIcon;
        break
      case "alert": //告警
        this.iconHtml = this.iconService.getAlertIcon;
        break
      case "all-alert":  //全部告警
        this.iconHtml = this.iconService.getallAlertIcon;
        break
      case "online": //在线
        this.iconHtml = this.iconService.getOnlineIcon;
        break
      case "offline": //离线
        this.iconHtml = this.iconService.getOfflineIcon;
        break
      case "abnormal": //故障
        this.iconHtml = this.iconService.getAbnormalIcon;
        break
      case "alert-detail": //告警详情
        this.iconHtml = this.iconService.getAlertDetailIcon;
        break
      case "network-status": //当前(网络)状态
        this.iconHtml = this.iconService.getNetworkStatusIcon;
        break
      case "device-working-status": //工作状态 - 设备
        this.iconHtml = this.iconService.getDeviceWorkingStatusIcon;
        break
      case "box-temperature": //箱体温度
        this.iconHtml = this.iconService.getBoxTemperatureIcon;
        break
      case "device-temperature": //设备温度
        this.iconHtml = this.iconService.getDeviceTemperatureIcon;
        break
      case "electric-inspection-status": //电检状态
        this.iconHtml = this.iconService.getElectricInspectionStatusIcon;
        break
      case "battery-voltage": //电池电压
        this.iconHtml = this.iconService.getBatteryVoltageIcon;
        break
      case "battery-status": //电池状态
        this.iconHtml = this.iconService.getBatteryStatusIcon;
        break
      case "remaining-battery": //剩余电量
        this.iconHtml = this.iconService.getRemainingBatteryIcon;
        break
      case "is-charging": //是否充电
        this.iconHtml = this.iconService.getIsChargingIcon;
        break
      case "sd-status": //SD卡状态
        this.iconHtml = this.iconService.getSDStatusIcon;
        break
      case "sd-freespace": //SD卡剩余空间
        this.iconHtml = this.iconService.getSDFreeSpaceIcon;
        break
      case "mains-status": //市电状态
        this.iconHtml = this.iconService.getMainsStatusIcon;
        break
      case "door-status": //箱门状态
        this.iconHtml = this.iconService.getDoorStatusIcon;
        break
      case "fan-status": //风扇状态
        this.iconHtml = this.iconService.getFanStatusIcon;
        break
      case "device-status": //设备状态
        this.iconHtml = this.iconService.getDeviceStatusIcon;
        break
      case "reboot": //重启
        this.iconHtml = this.iconService.getRebootIcon;
        break
      case "calibration": //校准
        this.iconHtml = this.iconService.getCalibrationIcon;
        break
      case "upgrade": //升级
        this.iconHtml = this.iconService.getUpgradeIcon;
        break
      case "remote-setting": //远程设置
        this.iconHtml = this.iconService.getRemoteSettingIcon;
        break
      case "soundLevelMeter-power": //声级计供电
        this.iconHtml = this.iconService.getSoundLevelMeterPowerIcon;
        break
      case "video-power": //视频监控供电
        this.iconHtml = this.iconService.getVideoPowerIcon;
        break
      case "meteorological-power": //气象供电
        this.iconHtml = this.iconService.getMeteorologicalPowerIcon;
        break
      case "fan-power": //风扇供电
        this.iconHtml = this.iconService.getFanPowerIcon;
        break
      case "actorDevice-power": //监测因子设备供电
        this.iconHtml = this.iconService.getactorDevicePowerIcon;
        break
      case "track-management": //航迹管理
        this.iconHtml = this.iconService.getTrackManagementIcon;
        break
      case "noise-event": //噪声事件导航
        this.iconHtml = this.iconService.getNoiseEventIcon;
        break
      case "monitoring-data": //监测数据导航
        this.iconHtml = this.iconService.getMonitoringDataIcon;
        break
      case "data-report": //数据报告
        this.iconHtml = this.iconService.getDataReportIcon;
        break
      case "evaluation": //评价
        this.iconHtml = this.iconService.getEvaluationIcon;
        break
      case "data-analysis": //数据分析
        this.iconHtml = this.iconService.getDataAnalysisIcon;
        break
      default:
        this.iconHtml = this.iconService.getAddIcon;
        break
    }
  }



  iconHtml;

  @Input()
  iconSize: string = "default";

  @Input()
  iconType: string = "add";

  @Input()
  tooltipTitle: string = "";

  @Input()
  toolTipPlacement: string = "top";

  @Input()
  iconColor: string = "#04a294";

  // @Output()
  // click = new EventEmitter<string>();

  // addIconClick() {
  //   this.click.emit("click");
  // }


}
